<div class="grid-4col input-grid-gaps">
    <app-select-input
        id="serviceId"
        [form]="form"
        [staticOptions]="store.globalGlobalStore.organizationStore.servicesInContext()"
        valueKey="id"
        [showClear]="false"
    >
        <ng-template #item let-data>
            <div class="flex gap-small">
                <div
                    class="stripe"
                    [style]="'background-color: ' + data.color + ';'">
                </div>
                <div class="flex-column gap-xx-small">
                    <div>
                        {{ data.name }}
                    </div>
                    @if (data.description) {
                        <div class="font-size-x-small text-secondary">
                            {{ data.description }}
                        </div>
                    }
                </div>
            </div>
        </ng-template>

        <ng-template #selectedItem let-data>
            <div class="flex gap-small">
                <div class="stripe" [style]="'background-color: ' + data.color + ';'"></div>
                <div>{{ data.name }}</div>
            </div>
        </ng-template>
    </app-select-input>
    <app-text-input
        id="registrationNumber"
        [form]="form"
        [label]="`${translatePrefix}registrationNumber`"
    ></app-text-input>
    <div class="fr-2"></div>

    <app-date-input
        id="date"
        [form]="form"
        [label]="`${translatePrefix}date`"
    ></app-date-input>
    <app-number-input
        id="duration"
        [form]="form"
        [useGrouping]="false"
        [showButtons]="true"
        [buttonStep]="10"
        [label]="`${translatePrefix}duration`"
    ></app-number-input>
    <app-multi-select-input
        id="userIds"
        [form]="form"
        [infiniteScroll]="userInfiniteScroll()"
        valueKey="id"
        filterBy="name,surname"
        class="fr-2"
        [label]="`${translatePrefix}users`"
    >
        <ng-template #item let-item>
            {{ item | formatPerson }}
        </ng-template>
        <ng-template #selectedItems let-items>
            @for (item of items; track $index) {
                <app-user-chip
                    [user]="item" [renderDetails]="false"
                    [renderType]="UserChipRenderTypeEnum.User"
                ></app-user-chip>
                <!--                <app-tag-->
                    <!--                    [label]="item | formatPerson"-->
                    <!--                ></app-tag>-->
            }
        </ng-template>
    </app-multi-select-input>

    <app-select-input
        id="mpsvGroupId"
        [form]="form"
        [staticOptions]="mpsvGroups()"
        [valueKey]="'id'"
        [labelKey]="'name'"
        [label]="`${translatePrefix}mpsvGroup`"
    ></app-select-input>
    <app-select-input
        id="sex"
        [form]="form"
        [staticOptions]="sexOptions"
        [label]="`${translatePrefix}sex`"
    ></app-select-input>
    <app-number-input
        id="numberOfPersons"
        [form]="form"
        [useGrouping]="false"
        [label]="`${translatePrefix}numberOfPersons`"
    ></app-number-input>
    <app-tags-input
        id="tags"
        [form]="form"
        [label]="`${translatePrefix}tags`"
        [suggestions]="tags()"
    ></app-tags-input>

    <app-service-pattern-wysiwyg
        id="text"
        [form]="form"
        editorKey="BasicSocialConsultingText"
        [serviceId]="serviceIdChange()"
        [usage]="ServicePatternStructureUsageEnum.BASIC_SOCIAL_CONSULTING_TEXT"
        (addedPattern)="formAddText(form, 'text', $event.content)"
        [patternGroups]="wysiwygPatterGroupsService"
        [placeholder]="`${translatePrefix}text`"
        class="fr-4"
    ></app-service-pattern-wysiwyg>
</div>
